import { MiniLoader } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

export const Loader = () => {
  return (
    <Container>
      <MiniLoader />
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
